import Vue from "vue";
import Vuetify from "vuetify/lib";
import "../assets/stylus/vuetify.styl";

Vue.use(Vuetify, {
  theme: {
    // primary: '#ee44aa',
    primary: "#DD122A",
    secondary: "#424242",
    accent: "#DD122A",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107"
  }
});
